export default __webpack_public_path__ + "static/media/bowser-logo.ddc697fd.webp";